import React, { FC } from 'react';
import ctaTypes from '../../../../enums/CTA.enums';
import { appendRootToInternalLink } from '../../../../utils/appendRootToInternalLink.utils';
import { targetLinkdsk } from '../../../../utils/targetDskLink';
import CTA from '../../CTA';
import RoutableNotEditableLink from '../../routableNotEditableLink';
import { TNavigationBarCtaDesktop } from '../types/navigationBar.types';
import useGetBuildAndPriceLink from '../../../../hooks/useGetBuildAndPriceLink';
import DictionaryTerm from '../../dictionaryTerm';

const NavigationBarCtaDesktop: FC<TNavigationBarCtaDesktop> = (props) => {
  const { isEditorial, editorialCTA, button1, isMobile, enableBuildPriceCTA } = props;
  const buildAndPriceUrl = useGetBuildAndPriceLink('series');
  const hasButtons = !!(button1?.label && button1?.url) || (enableBuildPriceCTA && buildAndPriceUrl);

  if (isEditorial) {
    if (editorialCTA?.value?.href && editorialCTA?.value?.text) {
      return (
        <div className={'navigation-bar-container__button-container'}>
          <CTA type={ctaTypes['primaryOrange']} field={editorialCTA} />
        </div>
      );
    } else {
      return null;
    }
  } else if (hasButtons) {
    return (
      <div className={'navigation-bar-container__button-container'}>
        {
          (enableBuildPriceCTA && buildAndPriceUrl) && (
            <RoutableNotEditableLink
              href={appendRootToInternalLink(buildAndPriceUrl)}
              className="navigation-bar-container__button"
            >
              <DictionaryTerm keyword={'cnhi-build-price'} />
            </RoutableNotEditableLink>
          )
        }
        {
          button1?.label && button1?.url && (
            <RoutableNotEditableLink
              href={appendRootToInternalLink(button1?.url)}
              target={targetLinkdsk({ value: { href: button1?.url, target: button1?.target } }, !isMobile)}
              className="navigation-bar-container__button"
            >
              {button1?.label}
            </RoutableNotEditableLink>
          )
        }
      </div>
    );
  } else {
    return null;
  }
};

export default NavigationBarCtaDesktop;
